import React from 'react';

function extractSingleValue(rows, widget) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return '-';
  }

  var first = rows[0];
  if (typeof first !== 'object' || first === null) {
    return String(first);
  }

  var configuredKey = widget.valueField || (widget.data && widget.data.valueField);
  if (configuredKey && first[configuredKey] !== undefined) {
    return String(first[configuredKey]);
  }

  var keys = Object.keys(first);
  if (keys.length === 0) {
    return '-';
  }

  return String(first[keys[0]]);
}

export default function SingleWidget({ rows, loading, widget }) {
  if (loading) {
    return <div>Loading...</div>;
  }

  return <div style={{ fontSize: '36px', fontWeight: 700 }}>{extractSingleValue(rows, widget)}</div>;
}
